import { render, staticRenderFns } from "./CustomerDetailsTable.vue?vue&type=template&id=27ffde0d&scoped=true"
import script from "./CustomerDetailsTable.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsTable.vue?vue&type=style&index=0&id=27ffde0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffde0d",
  null
  
)

export default component.exports